module.exports = __webpack_public_path__ + "media/images/front/mid_g/banner_cs_app_sp-d19b7f2f2a346ab298da618bf33f13a3.png";